module.exports = function (fox) {
	'use strict';

	fox.registerWidget('SimpleForm', {
		/**
		 * @param {Object} values
		 * @returns {Promise}
		 */
		submit: function (values) {
			return fox.Promise.resolve(values).then(function (_values) {
				this.dispatchEvent('submit', _values);

				return _values;
			}.bind(this));
		}
	}, 'Controller');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/simpleForm.js
// module id = 91
// module chunks = 0